var _g, _path, _g2, _g3, _path2, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 229,
    viewBox: "0 0 755 459",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_20_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.946 70.215C256.419 64.7363 266.871 62.0789 274.292 64.2794L698.213 189.989C705.634 192.19 707.213 198.415 701.74 203.893L504.054 401.798C498.581 407.276 488.129 409.934 480.708 407.733L56.7872 282.024C49.3664 279.823 47.7871 273.598 53.2598 268.119L250.946 70.215Z",
    fill: "black",
    fillOpacity: 0.07
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.946 7.21497C256.419 1.7363 266.871 -0.92114 274.292 1.27941L698.213 126.989C705.634 129.19 707.213 135.415 701.74 140.893L504.054 338.798C498.581 344.276 488.129 346.934 480.708 344.733L56.7872 219.024C49.3664 216.823 47.7871 210.598 53.2598 205.119L250.946 7.21497Z",
    fill: "#FBE414"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_20_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.44 184.085C142.81 183.603 140.531 184.169 139.35 185.351L132.396 192.305C131.214 193.487 131.577 194.836 133.206 195.319L141.024 197.634C142.653 198.117 144.932 197.55 146.114 196.369L153.068 189.415C154.25 188.233 153.887 186.884 152.257 186.401L144.44 184.085Z",
    fill: "#183153",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.165 185.293C132.626 184.739 126.062 186.784 122.395 190.452L117.741 195.106C117.002 195.844 117.229 196.687 118.247 196.989L145.831 205.16C146.849 205.461 148.274 205.107 149.012 204.369L153.666 199.715C157.139 196.242 156.957 192.372 153.649 190.077L144.345 199.381C143.517 200.208 141.922 200.604 140.782 200.267L129.276 196.859C128.136 196.521 127.882 195.576 128.709 194.749L138.165 185.293Z",
    fill: "#183153",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.782 197.866C113.225 197.423 114.079 197.211 114.69 197.392L147.142 207.004C147.753 207.185 147.889 207.691 147.446 208.134L145.466 210.113C145.023 210.556 144.169 210.769 143.558 210.588L111.106 200.975C110.495 200.794 110.359 200.289 110.802 199.845L112.782 197.866Z",
    fill: "#183153",
    fillOpacity: 0.15
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_20_6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 282.611,
    height: 184.434,
    rx: 20,
    transform: "matrix(0.95882 0.284015 -0.707107 0.707107 350.832 84.9781)",
    fill: "black",
    fillOpacity: 0.15
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_6",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 0,
    width: 655,
    height: 346
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.946 7.21497C256.419 1.7363 266.871 -0.92114 274.292 1.27941L698.213 126.989C705.634 129.19 707.213 135.415 701.74 140.893L504.054 338.798C498.581 344.276 488.129 346.934 480.708 344.733L56.7872 219.024C49.3664 216.823 47.7871 210.598 53.2598 205.119L250.946 7.21497Z",
    fill: "#FBE414"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_6)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_20_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.665 37.3357L201.741 54.4212C201.548 55.5547 202.072 56.5782 203.197 57.2666C204.323 57.9551 205.958 58.2522 207.743 58.0925L218.595 57.1254C219.934 59.8931 221.935 62.4313 224.496 64.6427L218.1 71.039C217.038 72.1005 216.596 73.2891 216.869 74.3432C217.143 75.3973 218.111 76.2306 219.56 76.6598L241.411 83.1324C242.86 83.5616 244.671 83.5514 246.446 83.1043C248.221 82.6571 249.815 81.8095 250.877 80.7479L257.273 74.3517C262.116 74.3189 267.096 73.8531 272.076 72.9671L276.476 78.4522C277.981 80.3248 281.995 80.6579 285.399 79.2017L310.174 68.5888C311.813 67.882 313.097 66.8487 313.748 65.714C314.398 64.5793 314.362 63.4351 313.647 62.5306L309.327 57.1364C312.864 54.3579 315.859 51.3581 318.218 48.2312L328.887 47.2773C332.588 46.9468 335.951 44.7521 336.348 42.4003L339.272 25.3148C339.465 24.1813 338.941 23.1578 337.816 22.4693C336.691 21.7809 335.056 21.4838 333.27 21.6434L322.418 22.6106C321.087 19.8525 319.104 17.3236 316.523 15.0949L322.919 8.69864C323.98 7.63707 324.423 6.44849 324.149 5.39439C323.875 4.34029 322.907 3.50699 321.459 3.07783L299.607 -3.3948C298.159 -3.82397 296.347 -3.81385 294.572 -3.36667C292.797 -2.91949 291.204 -2.07188 290.142 -1.01032L283.746 5.38591C278.903 5.41873 273.923 5.88453 268.943 6.77045L264.548 1.28698C264.191 0.839604 263.677 0.465292 263.035 0.185456C262.393 -0.0943799 261.636 -0.274246 260.807 -0.343854C259.978 -0.413461 259.094 -0.371443 258.205 -0.220204C257.316 -0.0689644 256.439 0.188528 255.625 0.537544L230.85 11.1504C229.212 11.8572 227.927 12.8905 227.276 14.0252C226.626 15.1599 226.662 16.3041 227.377 17.2086L231.697 22.6028C228.157 25.3799 225.158 28.3786 222.796 31.5047L212.127 32.4587C208.426 32.7892 205.063 34.9838 204.665 37.3357ZM286.517 23.8574C298.568 27.4271 301.188 37.5108 292.358 46.3406C283.528 55.1705 266.547 59.4482 254.496 55.8786C242.445 52.3089 239.825 42.2252 248.655 33.3953C257.485 24.5655 274.466 20.2877 286.517 23.8574Z",
    fill: "#F83226",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_20_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.997 94.0627L142.569 102.075C142.474 102.607 142.714 103.086 143.236 103.408C143.758 103.729 144.519 103.867 145.352 103.79L150.414 103.324C151.027 104.62 151.95 105.808 153.135 106.841L150.13 109.847C149.631 110.346 149.42 110.904 149.544 111.398C149.667 111.891 150.115 112.281 150.789 112.481L160.949 115.49C161.622 115.69 162.467 115.683 163.296 115.471C164.125 115.26 164.871 114.86 165.37 114.362L168.376 111.356C170.633 111.335 172.956 111.111 175.28 110.69L177.31 113.256C178.005 114.132 179.874 114.284 181.466 113.598L193.055 108.594C193.821 108.261 194.424 107.775 194.731 107.242C195.039 106.71 195.027 106.173 194.697 105.75L192.703 103.226C194.363 101.92 195.77 100.51 196.882 99.0417L201.858 98.5824C203.584 98.4232 205.16 97.3906 205.355 96.2876L206.783 88.2748C206.877 87.7432 206.637 87.264 206.115 86.9425C205.593 86.621 204.832 86.4836 203.999 86.5605L198.938 87.0262C198.328 85.7347 197.413 84.5515 196.218 83.5096L199.224 80.5038C199.723 80.005 199.934 79.4473 199.81 78.9534C199.687 78.4596 199.239 78.07 198.565 77.8705L188.405 74.861C187.731 74.6614 186.887 74.6682 186.058 74.8799C185.229 75.0915 184.483 75.4907 183.984 75.9895L180.978 78.9953C178.721 79.0161 176.398 79.2401 174.073 79.6611L172.046 77.0955C171.881 76.8862 171.643 76.7113 171.345 76.5808C171.047 76.4504 170.695 76.3669 170.309 76.3352C169.923 76.3035 169.51 76.3242 169.095 76.3961C168.68 76.468 168.271 76.5897 167.89 76.7543L156.302 81.7575C155.535 82.0908 154.933 82.5766 154.625 83.1093C154.317 83.642 154.33 84.1783 154.66 84.6015L156.653 87.1254C154.992 88.4313 153.583 89.8404 152.47 91.3086L147.493 91.7679C145.767 91.927 144.191 92.9597 143.997 94.0627ZM182.199 87.6514C187.803 89.3111 188.985 94.0353 184.836 98.1847C180.686 102.334 172.755 104.359 167.152 102.699C161.549 101.039 160.366 96.3149 164.516 92.1656C168.665 88.0162 176.596 85.9916 182.199 87.6514Z",
    fill: "#31E9DE",
    fillOpacity: 0.25
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_20_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.578 239.408C374.31 239.735 373.032 239.633 372.231 239.141L369.796 237.645C368.998 237.155 368.793 236.353 369.26 235.541L370.697 233.041C371.16 232.236 372.213 231.543 373.466 231.219L377.885 230.077C380.503 229.401 381.669 227.353 379.456 226.805C378.679 226.612 377.855 226.47 376.992 226.382C374.35 226.11 371.449 226.348 368.61 227.069C365.614 227.83 362.817 229.096 360.561 230.71C358.889 231.906 357.569 233.255 356.681 234.662C356.114 235.561 355.002 236.386 353.595 236.744L342.758 239.501L331.923 242.252C330.515 242.61 329.142 242.415 328.214 241.894C326.764 241.082 324.962 240.526 322.923 240.272C320.171 239.929 317.109 240.151 314.113 240.91C311.273 241.631 308.608 242.808 306.415 244.308C305.698 244.798 305.042 245.316 304.451 245.856C302.767 247.395 304.771 248.638 307.395 247.981L311.82 246.875C313.076 246.561 314.334 246.667 315.126 247.154L317.583 248.666C318.38 249.157 318.584 249.958 318.118 250.769L316.693 253.248C316.224 254.064 315.148 254.764 313.876 255.082L309.514 256.172C306.874 256.831 305.679 258.89 307.907 259.44C308.741 259.646 309.629 259.794 310.561 259.881C313.304 260.137 316.311 259.849 319.227 259.053C322.143 258.257 324.847 256.986 327.019 255.389C328.612 254.217 329.87 252.907 330.722 251.543C331.287 250.638 332.403 249.807 333.818 249.448L344.59 246.712L355.36 243.978C356.774 243.619 358.152 243.817 359.08 244.342C362.449 246.247 367.718 246.745 373.234 245.346C376.087 244.623 378.764 243.44 380.964 241.93C381.676 241.442 382.329 240.925 382.917 240.387C384.606 238.841 382.574 237.604 379.943 238.283L375.578 239.408Z",
    fill: "#7829F9",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_20_6",
    x: 0,
    y: 13.5063,
    width: 755,
    height: 445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_20_6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_20_6",
    x: 100.542,
    y: 173.913,
    width: 65.659,
    height: 46.7394,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_20_6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_20_6",
    x: 204.908,
    y: 64.5562,
    width: 432.408,
    height: 251.524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_20_6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_20_6",
    x: 176.702,
    y: -28.7095,
    width: 187.609,
    height: 137.157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_20_6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_20_6",
    x: 127.549,
    y: 59.7161,
    width: 94.2542,
    height: 70.9189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_20_6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_20_6",
    x: 293.831,
    y: 216.272,
    width: 99.7036,
    height: 53.6995,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_20_6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration4);
export default __webpack_public_path__ + "static/media/Illustration4.b12085aed2a436dd24c3839bd10057aa.svg";
export { ForwardRef as ReactComponent };